<template>
  <svg fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_10686_30304)">
      <path
        d="M6.66667 13.3334L5.83333 11.6667L4 12"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.33333"
      />
      <path
        d="M6.66667 2.66669L5.83333 4.33335L4 4.00002"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.33333"
      />
      <path
        d="M9.33325 13.3334L10.1666 11.6667L11.9999 12"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.33333"
      />
      <path
        d="M9.33325 2.66669L10.1666 4.33335L11.9999 4.00002"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.33333"
      />
      <path
        d="M11.3334 14L9.33341 10H6.66675"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.33333"
      />
      <path
        d="M11.3333 2L9.33325 6L10.3333 8"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.33333"
      />
      <path
        d="M1.33325 8H5.66659L6.66659 6"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.33333"
      />
      <path
        d="M13.3333 6.66669L12.3333 8.00002L13.3333 9.33335"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.33333"
      />
      <path
        d="M14.6666 8H10.3333L9.33325 10"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.33333"
      />
      <path
        d="M2.66675 6.66669L3.66675 8.00002L2.66675 9.33335"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.33333"
      />
      <path
        d="M4.66675 14L6.66675 10L5.66675 8"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.33333"
      />
      <path
        d="M4.66675 2L6.66675 6H9.33341"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.33333"
      />
    </g>
    <defs>
      <clipPath id="clip0_10686_30304">
        <rect fill="currentColor" height="16" width="16" />
      </clipPath>
    </defs>
  </svg>
</template>
